module.exports = __webpack_public_path__ + "static/media/214-Sturz-Milo_ID_1.fd48749f.mp3";